export default "__VITE_ASSET__BWji46nt__"